import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/Button';

interface CompanyProfile {
  name: string;
  logo: string;
  membershipDate: string;
  isVerified: boolean;
  notifications: number;
}

interface ProfileForm {
  companyName: string;
  taxNumber: string;
  taxOffice: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  description: string;
}

const Profil_kurumsal: React.FC = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState<CompanyProfile>({
    name: 'Yılmaz Bilgisayar Teknoloji ve Ticaret A.Ş.',
    logo: '../assets/images/company-logo.png',
    membershipDate: 'Ocak 2023',
    isVerified: true,
    notifications: 12
  });

  const [formData, setFormData] = useState<ProfileForm>({
    companyName: 'Yılmaz Bilgisayar Teknoloji ve Ticaret A.Ş.',
    taxNumber: '1234567890',
    taxOffice: 'Kadıköy',
    address: 'Bağdat Caddesi No:123 Kadıköy/İstanbul',
    phone: '0212 123 45 67',
    email: 'info@yilmazbilgisayar.com',
    website: 'www.yilmazbilgisayar.com',
    description: '20 yıllık tecrübemizle bilgisayar ve teknoloji ürünleri satışında hizmetinizdeyiz.'
  });

  const [activeTab, setActiveTab] = useState('profile');
  const [logoFile, setLogoFile] = useState<File | null>(null);

  const handleLogout = () => {
    // Logout logic here
    navigate('/');
  };

  const handleLogoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0]);
      // Preview logic here
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic here
    console.log('Form submitted:', formData);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="bg-light min-vh-100">
      {/* Header */}
      <header className="header sticky-top bg-white">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Logo */}
            <Link className="navbar-brand fw-bold text-primary" to="/">
              <i className="fas fa-laptop me-2" />
              SadeceBilgisayar.com
            </Link>
            {/* Arama Kutusu */}
            <div className="search-box mx-lg-4 flex-grow-1">
              <form className="d-flex">
                <div className="input-group">
                  <input
                    aria-label="Arama"
                    className="form-control"
                    placeholder="Dizüstü, masaüstü, parça ara..."
                    type="search"
                  />
                  <Button className="btn btn-primary" type="submit">
                    <i className="fas fa-search" />
                  </Button>
                </div>
              </form>
            </div>
            {/* Sağ Menü */}
            <div className="nav-right d-flex align-items-center">
              <Link className="btn btn-outline-primary me-3" to="/ilan-ver">
                <i className="fas fa-plus-circle me-2" />
                İlan Ver
              </Link>
              {/* Bildirimler */}
              <div className="dropdown me-3">
                <Button className="btn btn-link text-dark position-relative" data-bs-toggle="dropdown">
                  <i className="fas fa-bell fs-5" />
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    3
                  </span>
                </Button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Bildirimler</h6>
                  <Link className="dropdown-item" to="#">
                    İlanınıza yeni bir mesaj geldi
                  </Link>
                  <Link className="dropdown-item" to="#">
                    Takip ettiğiniz ürünün fiyatı düştü
                  </Link>
                  <Link className="dropdown-item" to="#">
                    Yeni bir teklif aldınız
                  </Link>
                </div>
              </div>
              {/* Mesajlar */}
              <div className="dropdown me-3">
                <Button className="btn btn-link text-dark position-relative" data-bs-toggle="dropdown">
                  <i className="fas fa-envelope fs-5" />
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    2
                  </span>
                </Button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Mesajlar</h6>
                  <Link className="dropdown-item" to="/mesajlar-kurumsal">
                    Tüm mesajları görüntüle
                  </Link>
                </div>
              </div>
              {/* Kullanıcı Menüsü */}
              <div className="dropdown">
                <Button className="btn btn-link text-dark dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
                  <img
                    alt="Şirket Logo"
                    className="rounded-circle me-2"
                    height="32"
                    src={profile.logo}
                    width="32"
                  />
                  <span>{profile.name}</span>
                </Button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link className="dropdown-item" to="/profil-kurumsal">
                      <i className="fas fa-building me-2" />
                      Şirket Profili
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/ilanlarim-kurumsal">
                      <i className="fas fa-list me-2" />
                      İlanlarım
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/favoriler-kurumsal">
                      <i className="fas fa-heart me-2" />
                      Favorilerim
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Button className="dropdown-item" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt me-2" />
                      Çıkış Yap
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Ana İçerik */}
      <main className="container mt-4">
        <div className="row">
          {/* Sol Menü */}
          <div className="col-md-3">
            <div className="card profile-sidebar">
              <div className="card-body text-center">
                {/* Şirket Logosu Bölümü */}
                <div className="profile-photo mb-3 position-relative">
                  <img
                    alt="Şirket Logo"
                    className="rounded"
                    height="150"
                    src={profile.logo}
                    width="150"
                  />
                  <label className="photo-edit-icon" htmlFor="logoInput">
                    <i className="fas fa-camera" />
                  </label>
                  <input
                    accept="image/*"
                    className="d-none"
                    id="logoInput"
                    type="file"
                    onChange={handleLogoChange}
                  />
                </div>
                <h5 className="mb-1">{profile.name}</h5>
                <p className="text-muted small">Üyelik: {profile.membershipDate}</p>
                {profile.isVerified && (
                  <div className="badge bg-primary mb-2">Onaylı Kurumsal Üye</div>
                )}
              </div>
              <div className="list-group list-group-flush">
                <Button
                  className={`list-group-item list-group-item-action ${activeTab === 'profile' ? 'active' : ''}`}
                  onClick={() => setActiveTab('profile')}
                >
                  <i className="fas fa-building me-2" />
                  Şirket Bilgileri
                </Button>
                <Button
                  className={`list-group-item list-group-item-action ${activeTab === 'stats' ? 'active' : ''}`}
                  onClick={() => setActiveTab('stats')}
                >
                  <i className="fas fa-chart-line me-2" />
                  İstatistikler
                </Button>
                <Button
                  className={`list-group-item list-group-item-action ${activeTab === 'notifications' ? 'active' : ''}`}
                  onClick={() => setActiveTab('notifications')}
                >
                  <i className="fas fa-bell me-2" />
                  Bildirimler
                  <span className="badge bg-danger rounded-pill float-end">
                    {profile.notifications}
                  </span>
                </Button>
                <Button
                  className={`list-group-item list-group-item-action ${activeTab === 'technical-support' ? 'active' : ''}`}
                  onClick={() => setActiveTab('technical-support')}
                >
                  <i className="fas fa-wrench me-2" />
                  Teknik Destek
                </Button>
                <Button
                  className={`list-group-item list-group-item-action ${activeTab === 'security' ? 'active' : ''}`}
                  onClick={() => setActiveTab('security')}
                >
                  <i className="fas fa-shield-alt me-2" />
                  Güvenlik
                </Button>
              </div>
            </div>
          </div>

          {/* Sağ İçerik */}
          <div className="col-md-9">
            <div className="tab-content">
              {/* Profil Bilgileri */}
              {activeTab === 'profile' && (
                <div className="tab-pane fade show active">
                  <div className="card mb-4">
                    <div className="card-header bg-light">
                      <h5 className="card-title mb-0">
                        <i className="fas fa-building text-primary me-2" />
                        <span className="text-primary">Profil Bilgileri</span>
                      </h5>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleFormSubmit}>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="companyName" className="form-label">
                              Şirket Adı
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="companyName"
                              name="companyName"
                              value={formData.companyName}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="taxNumber" className="form-label">
                              Vergi Numarası
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="taxNumber"
                              name="taxNumber"
                              value={formData.taxNumber}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="taxOffice" className="form-label">
                              Vergi Dairesi
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="taxOffice"
                              name="taxOffice"
                              value={formData.taxOffice}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="phone" className="form-label">
                              Telefon
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              id="phone"
                              name="phone"
                              value={formData.phone}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="address" className="form-label">
                            Adres
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="address"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <label htmlFor="email" className="form-label">
                              E-posta
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="col-md-6">
                            <label htmlFor="website" className="form-label">
                              Website
                            </label>
                            <input
                              type="url"
                              className="form-control"
                              id="website"
                              name="website"
                              value={formData.website}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="description" className="form-label">
                            Şirket Açıklaması
                          </label>
                          <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            rows={4}
                            value={formData.description}
                            onChange={handleInputChange}
                          />
                        </div>
                        <Button type="submit" className="btn btn-primary">
                          Kaydet
                        </Button>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Profil_kurumsal;
